import {EmptyControl, MaxLength, MinLength, NestedArray, Required} from '@hvlng/framework-bff/core';
import {HvlDateConverter} from '@hvlng/framework-bff/util';
import {JsonObject, JsonProperty} from 'json2typescript';
import {PerEntityInfoAttributesModel} from "./per-entity-info-attributes-model";

@JsonObject('KovanHrPerEntityInfoModel')
export class PerEntityInfoModel {
    @EmptyControl()
    @JsonProperty('entityName', String, true)
    entityName: string = null;

    @NestedArray(PerEntityInfoAttributesModel)
    @JsonProperty('attributes', [PerEntityInfoAttributesModel], true)
    attributes: Array<PerEntityInfoAttributesModel> = new Array<PerEntityInfoAttributesModel>();


}
